import { useQuery } from '@tanstack/react-query';
import { orpc } from '@/api/rpc/client';

export const DISCOUNT_DOCUMENTS_QUERY_KEY = 'discount-documents';

/**
 * Fetches documents associated with a discount.
 */
export function useGetDiscountDocuments(discountId: string | undefined) {
  return useQuery({
    ...orpc.accountsReceivable.discounts.getDocuments.queryOptions({
      input: { discountId: discountId ?? '' },
    }),
    queryKey: [DISCOUNT_DOCUMENTS_QUERY_KEY, discountId],
    enabled: !!discountId,
  });
}
